import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  isSignInWithEmailLink,
  signInWithEmailLink
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { useMode } from "../context/ModeContext";
import uiStyles from "../theme/uiStyles";

const EMAIL_LINK_STORAGE_KEY = "nextbiteEmailForSignIn";

export default function FinishSignUp() {
  const [email, setEmail] = useState(
    window.localStorage.getItem(EMAIL_LINK_STORAGE_KEY) || ""
  );
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();
  const { setMode } = useMode();

  useEffect(() => {
    const hasValidLink = isSignInWithEmailLink(auth, window.location.href);

    if (!hasValidLink) {
      setError("This sign-in link is invalid or has expired.");
      setLoading(false);
      return;
    }

    if (!email) {
      setLoading(false);
    }
  }, [email]);

  const completeSignIn = useCallback(async (overrideEmail) => {
    const resolvedEmail = (overrideEmail || email).trim();

    if (!resolvedEmail) {
      setError("Enter the same email address that received the sign-in link.");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError("");

    try {
      const userCredential = await signInWithEmailLink(
        auth,
        resolvedEmail,
        window.location.href
      );

      const user = userCredential.user;

      await setDoc(
        doc(db, "users", user.uid),
        {
          email: user.email,
          createdAt: new Date(),
          cuisine: "",
          location: "",
          texture: ""
        },
        { merge: true }
      );

      window.localStorage.removeItem(EMAIL_LINK_STORAGE_KEY);
      setMode("personal");
      nav("/home");
    } catch (signInError) {
      setError(signInError.message || "Unable to complete sign-in.");
      setLoading(false);
    }
  }, [email, nav, setMode]);

  useEffect(() => {
    if (isSignInWithEmailLink(auth, window.location.href) && email) {
      completeSignIn(email);
    }
  }, [completeSignIn, email]);

  return (
    <div style={uiStyles.page}>
      <div style={uiStyles.card}>
        <h2 style={{ textAlign: "center", marginBottom: "12px" }}>
          Finish Sign-In
        </h2>

        <p style={{ marginTop: 0, textAlign: "center", color: "#4b5563" }}>
          {loading
            ? "Checking your sign-in link..."
            : "Use the same email address that received the link."}
        </p>

        {error && (
          <p style={{ margin: 0, color: "#dc2626", textAlign: "center" }}>
            {error}
          </p>
        )}

        {!loading && (
          <>
            <input
              style={uiStyles.input}
              placeholder="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <button
              style={uiStyles.primaryBtn}
              onClick={() => completeSignIn(email)}
            >
              Complete Sign-In
            </button>
          </>
        )}
      </div>
    </div>
  );
}
